/* eslint-disable no-restricted-imports */
export {default as chalk} from 'chalk'
export * from 'chalk'
